<!--
 * @Description: 关于我们
-->
<template>
  <Layout>
    <div class="about_us">
      <section class="about_us_header">
        <img
          class="hidden-mobile"
          src="@/assets/images/aboutUs/about_us_banner_pc.png"
          alt=""
        />
        <img
          class="hidden-pc"
          src="@/assets/images/aboutUs/about_us_banner_mobile.png"
          alt=""
        />
      </section>

      <!-- 公司简介 -->
      <companyProfile></companyProfile>
      <!-- 关于我们时间线 -->
      <div class="time_line_box mb--50">
        <div class="container">
          <SectionTitle
            :title="$t('about_us.our_honors.title')"
            description="OUR HISTORY"
            textAlign="center"
          />
          <timeline></timeline>
        </div>
        <CoolLightBox
          :items="coolLightItems"
          :index="coolLightIndex"
          @close="coolLightIndex = null"
        >
        </CoolLightBox>
      </div>

      <whyChooseUs />
    </div>
  </Layout>
</template>

<script>
import Layout from "../../components/common/Layout";
import Timeline from "./TimeLine";
import whyChooseUs from "./whyChooseUs";
import companyProfile from "./companyProfile";
import SectionTitle from "@/components/elements/sectionTitle/SectionTitle";
// import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "aboutUsIndex",
  components: {
    Layout,
    whyChooseUs,
    companyProfile,
    Timeline,
    SectionTitle,
  },
  data() {
    return {
      identifyCode: "",
      // 验证码规则
      identifyCodes: "123456789ABCDEFGHGKMNPQRSTUVWXYZ",
      coolLightItems: [
        require("../../assets/images/aboutUs/time_line_img01.png"),
        require("../../assets/images/aboutUs/time_line_img02.png"),
        require("../../assets/images/aboutUs/time_line_img03.png"),
        require("../../assets/images/aboutUs/time_line_img04.png"),
        require("../../assets/images/aboutUs/time_line_img05.png"),
        require("../../assets/images/aboutUs/time_line_img06.png"),
        require("../../assets/images/aboutUs/time_line_img07.png"),
        require("../../assets/images/aboutUs/time_line_img08.png"),
        require("../../assets/images/aboutUs/time_line_img09.png"),
        require("../../assets/images/aboutUs/time_line_img10.png"),
        require("../../assets/images/aboutUs/time_line_img11.png"),
        require("../../assets/images/aboutUs/time_line_img12.png"),
        require("../../assets/images/aboutUs/time_line_img13.png"),
        require("../../assets/images/aboutUs/time_line_img14.png"),
        require("../../assets/images/aboutUs/time_line_img15.png"),
        require("../../assets/images/aboutUs/time_line_img16.png"),
        require("../../assets/images/aboutUs/time_line_img17.png"),
      ],
      coolLightIndex: null,
      timeLineCircle: require("../../assets/images/aboutUs/time_line_circle.png"),
      aboutUsMap: require("@/assets/images/aboutUs/aboutUs-map.png"),
      circle1: require("@/assets/images/aboutUs/circle1.png"),
      circle2: require("@/assets/images/aboutUs/circle2.png"),
      cityList: [
        { id: "01", city: this.$t("about_us.our_scale.tab.tab01.name") },
        { id: "02", city: this.$t("about_us.our_scale.tab.tab02.name") },
        { id: "03", city: this.$t("about_us.our_scale.tab.tab03.name") },
        { id: "04", city: this.$t("about_us.our_scale.tab.tab04.name") },
        { id: "05", city: this.$t("about_us.our_scale.tab.tab05.name") },
        { id: "06", city: this.$t("about_us.our_scale.tab.tab06.name") },
      ],
      dataList: [
        {
          id: "001",
          company: this.$t("about_us.our_scale.tab.tab01.title"),
          time: this.$t("about_us.our_scale.tab.tab01.date"),
          address: this.$t("about_us.our_scale.tab.tab01.address"),
          img1: require("@/assets/images/aboutUs/xian01.png"),
          img2: require("@/assets/images/aboutUs/xian02.png"),
        },
        {
          id: "002",
          company: this.$t("about_us.our_scale.tab.tab02.title"),
          time: this.$t("about_us.our_scale.tab.tab02.date"),
          address: this.$t("about_us.our_scale.tab.tab02.address"),
          img1: require("@/assets/images/aboutUs/zhengzhou01.png"),
          img2: require("@/assets/images/aboutUs/zhengzhou02.png"),
        },
        {
          id: "003",
          company: this.$t("about_us.our_scale.tab.tab03.title"),
          time: this.$t("about_us.our_scale.tab.tab03.date"),
          address: this.$t("about_us.our_scale.tab.tab03.address"),
          img1: require("@/assets/images/aboutUs/changzhou01.png"),
          img2: require("@/assets/images/aboutUs/changzhou02.png"),
        },
        {
          id: "004",
          company: this.$t("about_us.our_scale.tab.tab04.title"),
          time: this.$t("about_us.our_scale.tab.tab04.date"),
          address: this.$t("about_us.our_scale.tab.tab04.address"),
          img1: require("@/assets/images/aboutUs/wuhan01.png"),
          img2: require("@/assets/images/aboutUs/wuhan02.png"),
        },
        {
          id: "005",
          company: this.$t("about_us.our_scale.tab.tab05.title"),
          time: this.$t("about_us.our_scale.tab.tab05.date"),
          address: this.$t("about_us.our_scale.tab.tab05.address"),
          img1: require("@/assets/images/aboutUs/shanghai.png"),
          img2: require("@/assets/images/aboutUs/shanghai02.png"),
        },
        {
          id: "006",
          company: this.$t("about_us.our_scale.tab.tab06.title"),
          time: this.$t("about_us.our_scale.tab.tab06.date"),
          address: this.$t("about_us.our_scale.tab.tab06.address"),
          img1: require("@/assets/images/aboutUs/changsha01.png"),
          img2: require("@/assets/images/aboutUs/changsha02.png"),
        },
      ],
      showDetail: "4",
      timeLineData: [
        {
          id: "1",
          date: "Step-1",
          title: "Your working process you can present.",
          description:
            "Lorem ipsum dolor sit amet at — consectetur adipisicing elit. Hic, expedita. Incidunt laboriosam.",
          image: "timeline-01",
          workingStep: [
            {
              stepTitle: "Gain your works",
              stepDescription:
                "Lorem ipsum dolor sit amet at consectetur adipisicing",
            },
            {
              stepTitle: "Working process",
              stepDescription:
                "Lorem ipsum dolor sit amet at consectetur adipisicing",
            },
          ],
        },
        {
          id: "2",
          date: "Step-2",
          title: "Our compnay working process to present.",
          description:
            "Lorem ipsum dolor sit amet at — consectetur adipisicing elit. Hic, expedita. Incidunt laboriosam.",
          image: "timeline-02",
          workingStep: [
            {
              stepTitle: "Follow this process",
              stepDescription:
                "Lorem ipsum dolor sit amet at consectetur adipisicing",
            },
            {
              stepTitle: "Working experience",
              stepDescription:
                "Lorem ipsum dolor sit amet at consectetur adipisicing",
            },
          ],
        },
      ],
    };
  },
  mounted() {},
  methods: {
    getIdentifyCode(res) {
      console.log("res===", res);
    },

    //切换点击不同城市后的详情切换
    showDetailBtn(index) {
      this.showDetail = index;
    },
  },
};
</script>
